interface StatusUnavailableProps {
  message: string;
  onRetry?: () => void;
  /** Container classes, so each panel keeps the shape of what it replaces. */
  className?: string;
}

/**
 * Shown when a subscription/credit read failed and there is nothing cached.
 *
 * Every surface that reads entitlement used to render a failed read as either a
 * permanent spinner or a plausible-looking wrong value (a subscriber's plan shown
 * as "Free"). Both leave the user stuck with no idea anything broke and no way to
 * ask again. Say that we don't know, and give them the retry.
 */
export const StatusUnavailable = ({
  message,
  onRetry,
  className = '',
}: StatusUnavailableProps) => (
  <div
    className={`
      flex w-full flex-col items-center justify-center gap-3 rounded-2xl border
      border-gray-200 bg-white p-6 text-center
      ${className}
    `}
    role="alert"
  >
    <p className="text-sm text-gray-600">{message}</p>
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        className={`
          rounded-full border border-gray-800 px-4 py-1.5 text-sm font-semibold
          text-gray-800 transition-colors duration-75
          hover:border-yellow-500 hover:bg-yellow-400
        `}
      >
        Try again
      </button>
    )}
  </div>
);
